import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.home',
        path: `${APP_PREFIX_PATH}/dashboard/home`,
        component: React.lazy(() => import('views/app-views/dashboards/home')),
    }
]